import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width="35px"
    height="35px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
    xmlSpace="preserve"
  >
    <style type="text/css">
      {
        "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#3A559F;}\n\t.st2{fill:#F4F4F4;}\n\t.st3{fill:#FF0084;}\n\t.st4{fill:#0063DB;}\n\t.st5{fill:#00ACED;}\n\t.st6{fill:#FFEC06;}\n\t.st7{fill:#FF0000;}\n\t.st8{fill:#25D366;}\n\t.st9{fill:#0088FF;}\n\t.st10{fill:#314358;}\n\t.st11{fill:#EE6996;}\n\t.st12{fill:#01AEF3;}\n\t.st13{fill:#FFFEFF;}\n\t.st14{fill:#F06A35;}\n\t.st15{fill:#00ADEF;}\n\t.st16{fill:#1769FF;}\n\t.st17{fill:#1AB7EA;}\n\t.st18{fill:#6001D1;}\n\t.st19{fill:#E41214;}\n\t.st20{fill:#05CE78;}\n\t.st21{fill:#7B519C;}\n\t.st22{fill:#FF4500;}\n\t.st23{fill:#00F076;}\n\t.st24{fill:#FFC900;}\n\t.st25{fill:#00D6FF;}\n\t.st26{fill:#FF3A44;}\n\t.st27{fill:#FF6A36;}\n\t.st28{fill:#0061FE;}\n\t.st29{fill:#F7981C;}\n\t.st30{fill:#EE1B22;}\n\t.st31{fill:#EF3561;}\n\t.st32{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st33{fill:#0097D3;}\n\t.st34{fill:#01308A;}\n\t.st35{fill:#019CDE;}\n\t.st36{fill:#FFD049;}\n\t.st37{fill:#16A05D;}\n\t.st38{fill:#4486F4;}\n\t.st39{fill:none;}\n\t.st40{fill:#34A853;}\n\t.st41{fill:#4285F4;}\n\t.st42{fill:#FBBC05;}\n\t.st43{fill:#EA4335;}\n"
      }
    </style>
    <g>
      <g>
        <path
          className="st5"
          d="M10.5,30.6c-3.5,0-7-1-10-3c-0.4-0.3-0.5-0.7-0.4-1.2c0.2-0.4,0.6-0.7,1.1-0.7c2.3,0.3,4.5-0.1,6.4-1.1 c-1.9-0.8-3.5-2.4-4.1-4.5c-0.1-0.3,0-0.7,0.2-1c0,0,0.1-0.1,0.1-0.1c-1.5-1.4-2.5-3.4-2.5-5.5c0-0.4,0.2-0.7,0.5-0.9 c0.1-0.1,0.3-0.1,0.4-0.1C1.6,11.4,1.3,10.2,1.3,9c0-1.3,0.3-2.6,1-3.7C2.4,5,2.7,4.8,3.1,4.8c0.3,0,0.7,0.1,0.9,0.4 c2.3,2.9,5.5,5,9.1,5.8c0-4.4,3.6-8,8-8c2.2,0,4.3,0.9,5.8,2.5c1-0.3,1.8-0.8,2.7-1.3c0.4-0.2,0.9-0.2,1.2,0.1 C31,4.6,31.1,5,30.9,5.4l-1.5,3l1.9,0.6C31.7,9.2,32,9.5,32,9.9c0,0.4-0.1,0.8-0.5,1l-2.6,1.5C28.6,21.4,21.7,30.6,10.5,30.6z"
        />
      </g>
    </g>
  </svg>
);
export default SVGComponent;
